export default __webpack_public_path__ + "static/media/solution_for_you.100e6395.svg";